import { createSelector } from "reselect";
import { StoreVisits } from "./reducer";

const storeVisits = (state: any) => state.storeVisits;

export const getViewContext = createSelector(
  storeVisits,
  (storeVisits: StoreVisits.StoreVisitsContainerState) => {
    const { startDate, endDate, publicationIds } = storeVisits;
    const numPublications = publicationIds ? publicationIds.length : 0;
    return { startDate, endDate, numPublications: `${numPublications}` };
  }
);



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/selectors.ts